export const includesCaseInsensitive = (str?: string, substr?: string) => {
  if (!str || !substr) {
    return false;
  }
  return str.toLowerCase().includes(substr.toLowerCase());
}
